import localeDataset from '@wix/locale-dataset-javascript';

// Formatting copied from
// https://github.com/wix-private/address-formatting-evaluator/blob/master/packages/address-formatting-evaluator-client/src/utils.ts

function formatStreetNumber(streetAddress) {
  const number = (streetAddress == null ? void 0 : streetAddress.number) || '';
  const apt = streetAddress != null && streetAddress.apt ? `-${streetAddress.apt}` : '';
  return number ? `${number}${apt}` : '';
}
function formatAddressLine(isStreetFormat, streetAddress, addressLine) {
  if (!isStreetFormat) {
    return addressLine;
  }
  const streetNumber = formatStreetNumber(streetAddress);
  return `${(streetAddress == null ? void 0 : streetAddress.name) || ''} ${streetNumber}`;
}
export function formatMultilineAddress(submission, options) {
  const country = submission.country ? localeDataset.getCountryByShortKey(submission.country) : undefined;
  const streetAddress = {
    name: submission.streetName,
    number: submission.streetNumber,
    apt: submission.apartment
  };
  const isStreetFormat = Object.values(streetAddress).some(Boolean);
  const resolvedCountry = country && options != null && options.translateCountry ? options.translateCountry(country.displayName, options.language) : submission.country;
  const formattedAddress = localeDataset.getFormattedAddress({
    country: resolvedCountry,
    subdivision: submission.subdivision,
    city: submission.city,
    zipCode: submission.postalCode,
    addressLine1: formatAddressLine(isStreetFormat, streetAddress, submission.addressLine),
    addressLine2: submission.addressLine2
  }, country == null ? void 0 : country.key);
  return formattedAddress.replace(/^[\s,]+|[\s,]+$/g, '');
}
//# sourceMappingURL=format-multiline-address.js.map